<wbo-edit-grid [data]="model.data[fieldName]" [editable]="true" [entityPath]="fieldName" [removable]="true"
               [title]="'wbo.report.access-role-selection.title'">
    <wbo-text-column [title]="'wbo.report.access-role-selection.column.name'" field="name"></wbo-text-column>
    <wbo-edit-grid-add-row [customAdd]="true">
        <wbo-edit-grid-add-row-quick-add (onSelect)="addFromAccessRole([$event])">
            <wbo-access-role-single-select-edit-control></wbo-access-role-single-select-edit-control>
        </wbo-edit-grid-add-row-quick-add>
        <wbo-edit-grid-add-row-actions>
            <wbo-edit-grid-add-row-search (onSelect)="addFromAccessRole($event)"
                                          [searchComponent]="AccessRoleSearchPageComponent"></wbo-edit-grid-add-row-search>
        </wbo-edit-grid-add-row-actions>
    </wbo-edit-grid-add-row>
</wbo-edit-grid>
